import React, { useState, useEffect } from 'react';
import './index.css';

// Text nội dung đa ngôn ngữ
const translations = {
  vi: {
    title: 'PDF QRCode Viewer',
    description: 'Công cụ xem và chia sẻ file PDF qua mã QR',
    linkText: 'Tạo QR code cho PDF tại qrcode-gen.com',
    highlightText: 'Quét mã QR để xem PDF từ mọi thiết bị'
  },
  en: {
    title: 'PDF QRCode Viewer',
    description: 'View and share PDF files through QR codes',
    linkText: 'Create QR codes for PDF at qrcode-gen.com',
    highlightText: 'Scan QR code to view PDF on any device'
  }
};

const Home = () => {
  // Xác định ngôn ngữ dựa trên cài đặt của trình duyệt
  const [lang, setLang] = useState('en');
  
  useEffect(() => {
    // Lấy ngôn ngữ từ trình duyệt
    const browserLang = navigator.language.split('-')[0];
    // Chỉ sử dụng tiếng Việt nếu browser language là 'vi', ngược lại mặc định tiếng Anh
    if (browserLang === 'vi') {
      setLang('vi');
    }
  }, []);
  
  const text = translations[lang] || translations['en'];

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="logo-animation">
          <img src="/images/pdf.png" alt="PDF QRCode Viewer" className="animated-logo" />
        </div>
        
        <h1 className="app-title">{text.title}</h1>
        
        <p className="app-description">
          {text.description}
        </p>
        
        <a href="https://qrcode-gen.com" target="_blank" rel="noopener noreferrer" className="qrcode-link">
          <span className="qrcode-link-icon">✓</span> {text.linkText}
        </a>
        
        <div className="qr-highlight">
          <div className="qr-highlight-icon">🔍</div>
          <p>{text.highlightText}</p>
        </div>
      </div>
      
      <div className="green-accent"></div>
    </div>
  );
};

export default Home; 